export default class MasterDataConstants{
    static ITEMS_PER_PAGE = 12
}